import { useCallback, useEffect, useState } from "react";
import dayjs from "dayjs";
import MailingsService from "../../../services/mailings";
import { DATE_FORMAT, PDF_TYPE } from "../../../lib/constants";
import { FormInstance } from "antd";

export const useFetchData = (
  id: string | null | undefined,
  mailingType: 1 | 2 | 3,
  form: FormInstance,
  setInitialFiles?: React.Dispatch<React.SetStateAction<string[]>>,
  setData?: React.Dispatch<React.SetStateAction<any>>
) => {
  const [isLoading, setIsLoading] = useState<boolean>(!!id);

  const [sendTo, setSendTo] = useState<any>([]);

  const setReceipients = useCallback(
    (item: any, receipients: any[]) =>
      receipients.push(
        item.receiverId
          ? {
              id: item.receiverId,
              number: item.receiverNumber,
              email: item.email,
              name: item.receiverName,
              role: item.receiverType,
              i: item.receiverNumber
            }
          : {
              isEmail: true,
              email: item.email,
              name: item.email,
              i: item.email
            }
      ),
    []
  );

  useEffect(() => {
    if (id) {
      setIsLoading(true);

      MailingsService.get(id, mailingType)
        .then((res: any) => {
          setIsLoading(false);

          const { email, date, attachments, status } = res;

          const { receiverName, receiverType, receiverId } = res;

          let receiverValue;

          const receipients: any[] = [];

          if (status === 5) {
            res.scheduledRecipients.forEach((item: any) => {
              setReceipients(item, receipients);
            });

            setSendTo(receipients);
          } else {
            setReceipients(res, receipients);

            setSendTo(receipients);

            receiverValue = receiverId ? `${receiverName} | ${receiverType === 1 ? "Buyer" : "Seller"}` : email;
          }

          const fileIds: string[] = [];

          const entity = {
            ...res,
            date: dayjs(date).format(DATE_FORMAT),
            sendTo: Object.keys(receipients)
          };

          if (status === 5) {
            entity.scheduledDate = date;
          }

          if (attachments && attachments.length > 0) {
            entity.fileList = attachments.map((file: any) => {
              fileIds.push(file.id);

              return {
                name: file.fileName,
                type: PDF_TYPE,
                status: "done",
                size: 1000,
                id: file.id,
                response: file.id
              };
            });
          } else if (res.missingMigratedFilePath) {
            entity.fileList = [
              {
                name: res.missingMigratedFilePath,
                status: "error",
                isMissing: true
              }
            ];
          }

          if (mailingType === 2) {
            entity.email = [receiverValue];
          }

          setInitialFiles && setInitialFiles(fileIds);

          setData && setData(entity);

          form.setFieldsValue(entity);
        })
        .catch(() => setIsLoading(false));
    }
  }, [id, mailingType, form, setInitialFiles, setReceipients, setData]);

  return { isLoading, sendTo, setIsLoading };
};
